var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4, _circle, _rect6, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddPowerOfAttorney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 79,
    viewBox: "0 0 103 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.291 69.3153H64.3698V67.3941C64.3698 65.2808 62.6407 63.5518 60.5274 63.5518H29.7885C27.6752 63.5518 25.9462 65.2808 25.9462 67.3941V69.3153H24.025C21.9117 69.3153 20.1826 71.0444 20.1826 73.1577C20.1826 75.271 21.9117 77.0001 24.025 77.0001H66.291C68.4043 77.0001 70.1334 75.271 70.1334 73.1577C70.1334 71.0444 68.4043 69.3153 66.291 69.3153Z",
    fill: "white",
    stroke: "#090927",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.8219,
    y: 9.57129,
    width: 19.0267,
    height: 24.7607,
    transform: "rotate(45 64.8219 9.57129)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5076,
    y: 28.7031,
    width: 34.9965,
    height: 10.5629,
    transform: "rotate(45 74.5076 28.7031)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3438,
    y: 3.56201,
    width: 19.2877,
    height: 8.20195,
    transform: "rotate(45 70.3438 3.56201)",
    fill: "#e2d1fa"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7804,
    y: 27.6128,
    width: 18.4335,
    height: 7.94032,
    transform: "rotate(45 46.7804 27.6128)",
    fill: "#e2d1fa"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0491,
    y: 2.99121,
    width: 20,
    height: 42.3675,
    rx: 2,
    transform: "rotate(45 70.0491 2.99121)",
    stroke: "#090927",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6826 27.5L59.1826 40",
    stroke: "#090927",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1826 9L79.1826 24",
    stroke: "#090927",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0405 35.9287L73.1116 28.8576L97.1501 52.8961C98.7122 54.4582 98.7122 56.9909 97.1501 58.553L95.7359 59.9672C94.1738 61.5293 91.6411 61.5293 90.079 59.9672L66.0405 35.9287Z",
    stroke: "#090927",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 17.3574,
    r: 13,
    fill: "#e2d1fa",
    stroke: "#090927",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 10.8574,
    width: 3,
    height: 13,
    rx: 1.5,
    fill: "#090927"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 18.8574,
    width: 3,
    height: 13,
    rx: 1.5,
    transform: "rotate(-90 8.5 18.8574)",
    fill: "#090927"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPowerOfAttorney);
export default __webpack_public_path__ + "static/media/add-power-of-attorney.b3e36abeabb1068e398a82f0e8fa3ce6.svg";
export { ForwardRef as ReactComponent };